export const myProjects = [
  {id:1,
    projectTitle: "Rock-Paper-Scissor",
    category: ["html-css"],
    imgPath: "./Images/Rock-Paper-Scissor.png",
    GitHubLink : "https://github.com/AminEaabada/Rock-Paper-Scissor" ,
    IframLink : ' https://amineaabada.github.io/Rock-Paper-Scissor/',
    description : '"🪨✂️📄 Rock-Paper-Scissors Game 🕹️: Simple yet addictive implementation of the classic game in Javascript. Features a user-friendly CLI interface, random AI opponent, and score tracking.',
  },
  {id:2,
    projectTitle: "Loader-Eye-Moving",
    category: ["html-css"],
    imgPath: "./Images/Loader-Eye-Moving.png",
    GitHubLink : "https://github.com/AminEaabada/Loader-Eye-Moving" ,
    IframLink : 'https://amineaabada.github.io/Loader-Eye-Moving/',
    description : '"👀✨ Loader-Eye-Moving: Engaging CSS loader with animated eye movement. Elevate your web design with this lightweight, eye-catching loading animation..',
  },
  { id:3,
    projectTitle: "Guessing-Game", 
    category: ["html-css"], 
    imgPath: "./Images/Guessing-Game.png" , 
    GitHubLink : "https://github.com/AminEaabada/Guessing-Game" ,
    IframLink : 'https://amineaabada.github.io/Guessing-Game/',
    description : '"🎲🤔 Guessing Game: Interactive Javascript game where users guess a randomly generated number. Enjoy a fun and challenging experience with hints, score tracking, and customizable difficulty levels."',
  },
  {id:4,
    projectTitle: " Change-Items-Place",
    category: ["html-css"],
    imgPath: "./Images/Change-Items-Place.png",
    GitHubLink : "https://github.com/AminEaabada/-Change-Items-Place" ,
    IframLink : 'https://amineaabada.github.io/Change-Items-Place/',
    description : '"🔄📦 Change Items Place: JavaScript script to shuffle and rearrange items in a list. Simple yet powerful tool for reordering elements dynamically. Perfect for randomized presentations, list variations, or any scenario requiring item reordering. Boost versatility in your projects with ease!"',
  },
  { id:5,
    projectTitle: "Converter_To_Pixel", 
    category: ["html-css"], 
    imgPath: "./Images/Converter_To_Pixel.png" ,
    GitHubLink : "https://github.com/AminEaabada/Converter_To_Pixel" ,
    IframLink : 'https://amineaabada.github.io/Converter_To_Pixel/',
    description : '"📏🔄 Convert All CSS Units to Pixels: JavaScript script for seamless conversion of various CSS units to pixels. Enhance web development precision by standardizing measurements effortlessly. Customizable, easy-to-use tool for optimizing stylesheets. Simplify unit conversions in your projects!"',
  },
  {id:6,
    projectTitle: "Analog-Clock",
    category: ["javascript"],
    imgPath: "./Images/Analog-Clock.png",
    GitHubLink : "https://github.com/AminEaabada/Analog-Clock" ,
    IframLink : 'https://amineaabada.github.io/Analog-Clock/',
    description : '"The Analog Clock project is a visually appealing and functional representation of time. Combining aesthetic design with accurate timekeeping, it provides a classic and intuitive way for users to read and understand the current time in a digital environment."',
  },
  {id:7,
    projectTitle: "Detect-Device-Battery",
    category: ["javascript"],
    imgPath: "./Images/Detect-Device-Battery.jpg",
    GitHubLink : "https://github.com/AminEaabada/-Detect-Device-Battery" ,
    IframLink : ' https://amineaabada.github.io/-Detect-Device-Battery/',
    description : '"The Detect Device Battery tool provides real-time information about a device is battery status, helping optimize user experiences for different power levels. Developers can create responsive applications that adapt to varying battery conditions, enhancing usability and ensuring efficient use of resources across a wide range of devices and platforms."',
  },
  {id:8,
    projectTitle: "Count-Down",
    category: ["html-css"],
    imgPath: "./Images/Count-Down.png",
    GitHubLink : "https://github.com/AminEaabada/Count-Down" ,
    IframLink : 'https://amineaabada.github.io/Count-Down/',
    description : '"⏳🚀 Count-Down App: Simple yet powerful countdown timer built with JavaScript, HTML, and CSS. Enhance your project with an interactive and customizable timer. Easy integration, sleek design, and precise time tracking. Elevate user experience! #JavaScript #HTML #CSS #CountdownApp"',
  },
  {id:9,
    projectTitle: "Flip-a-Coin-Game ",
    category: ["javascript"],
    imgPath: "./Images/Flip-A-Coin.jpg",
    GitHubLink : "https://github.com/AminEaabada/Flip-a-Coin-Game" ,
    IframLink : 'https://amineaabada.github.io/Flip-a-Coin-Game/',
    description : '"Flip a Coin Game is a virtual coin toss experience that adds an element of chance to decision-making. With a simple click, users can simulate the age-old coin flip, making it easy to resolve dilemmas or make spontaneous choices. It is a fun and quick tool for those seeking a random outcome in a playful way."',
  },
  {id:10,
    projectTitle: "Type-Test-App ",
    category: ["javascript"],
    imgPath: "./Images/Type-Test-App.jpg",
    GitHubLink : "https://github.com/AminEaabada/Type-Test-App" ,
    IframLink : 'https://amineaabada.github.io/Type-Test-App/',
    description : '"The Type Test App is a platform designed for users to assess and improve their typing skills. Offering a variety of exercises and challenges, it measures typing speed, accuracy, and technique. Ideal for honing keyboard proficiency, this app provides a structured and engaging way to enhance typing capabilities."',
  },
  {id:11,
    projectTitle: "-Upload-Photo",
    category: ["html-css"],
    imgPath: "./Images/Upload-Photo.png",
    GitHubLink : "https://github.com/AminEaabada/-Upload-Photo" ,
    IframLink : 'https://amineaabada.github.io/-Upload-Photo/',
    description : '"📸✨ Upload Photo: Modern photo uploading feature crafted with JavaScript, HTML, and CSS. Seamlessly integrate this user-friendly component into your web app. Streamlined design, drag-and-drop functionality, and progress tracking. Elevate your image handling experience! #JavaScript #HTML #CSS #PhotoUpload',
  },
  {id:12,
    projectTitle: "Tic-Tac-Toe ",
    category: ["javascript"],
    imgPath: "./Images/tic-tac-toe.png",
    GitHubLink : "https://github.com/AminEaabada/Tic-Tac-Toe",
    IframLink : 'https://amineaabada.github.io/Tic-Tac-Toe/',
    description : '"TIC-TAC-TOE is a classic two-player game where opponents take turns marking spaces in a 3x3 grid. With a simple yet strategic gameplay, it offers a quick and enjoyable way to challenge friends or AI. This digital version combines nostalgia with modern convenience for a timeless gaming experience."',
  },
  {id:13,
    projectTitle: "Rich-Text-Editor",
    category: ["javascript"],
    imgPath: "./Images/Rich-Text-Editor.png",
    GitHubLink : "https://github.com/AminEaabada/Rich-Text-Editor",
    IframLink : 'https://amineaabada.github.io/Rich-Text-Editor/',
    description : '"A Rich Text Editor empowers users to create, edit, and format text with diverse styling options, including formatting, font styles, hyperlinks, and multimedia integration. Widely used in apps, blogs, and content management systems, it enhances editing with a dynamic and user-friendly interface."',
  }, 
  {id:14,
    projectTitle: "Pixel-Art-Generator",
    category: ["javascript"],
    imgPath: "./Images/pixel-art-generator.jpg",
    GitHubLink : "https://github.com/AminEaabada/Pixel-Art-Generator" ,
    IframLink : 'https://amineaabada.github.io/Pixel-Art-Generator/',
    description : '"Pixel Art Generator is a creative tool that transforms images into pixelated artworks, adding a retro aesthetic. With features like color customization and pixel size adjustment, it offers a fun and nostalgic way to generate pixel art for various design projects and digital creations."',
  },
  {id:15,
    projectTitle: "Balloon-Popping-Game",
    category: ["javascript"],
    imgPath: "./Images/Pop-The-Balloons.png",
    GitHubLink : "https://github.com/AminEaabada/Balloon-Popping-Game" ,
    IframLink : 'https://amineaabada.github.io/Balloon-Popping-Game/',
    description : '"The Balloon-Popping-Game offers a delightful experience where players aim to burst balloons in a fun and engaging environment. With vibrant graphics and challenging levels, it provides entertainment and quick reflex challenges, making it an enjoyable pastime for all ages."',
  }, 
  {id:16,
    projectTitle: "Translator-App",
    category: ["javascript"],
    imgPath: "./Images/Translator-App.png",
    GitHubLink : "https://github.com/AminEaabada/Translator-App" ,
    IframLink : 'https://amineaabada.github.io/Translator-App/',
    description : '"The Translator App is a versatile tool facilitating seamless language translation. With support for multiple languages, it empowers users to translate text or speech, fostering effective communication. Whether for travel, business, or learning, this app ensures linguistic accessibility and understanding."',
  },
  {id:17,
    projectTitle: "Generator-Password",
    category: ["javascript"],
    imgPath: "./Images/Generate-Password.png",
    GitHubLink : "https://github.com/AminEaabada/-Generator-Password" ,
    IframLink : 'https://amineaabada.github.io/-Generator-Password/',
    description : '"The Password Generator is a secure tool that creates strong, random passwords with customizable criteria such as length, characters, and complexity. It enhances online security by providing unique and robust passwords, ensuring better protection for users accounts and sensitive information."',
  },
  {id:18,
    projectTitle: "QR-Code-Generator",
    category: ["javascript"],
    imgPath: "./Images/QR-Code-Generator.jpg",
    GitHubLink : "https://github.com/AminEaabada/QR-Code-Generator" ,
    IframLink : 'https://amineaabada.github.io/QR-Code-Generator/',
    description : '"The QR Code Generator is a versatile tool that transforms information into quick-response codes, enabling seamless sharing and access. With customizable options, it efficiently generates QR codes for various applications, such as marketing, event management, and contactless transactions, offering a convenient and efficient way to share information in the digital realm."',
  },
  {id:19,
    projectTitle: "Filter-Project ",
    category: ["javascript"],
    imgPath: "./Images/Filter-Project.png",
    GitHubLink : "https://github.com/AminEaabada/Filter-Project" ,
    IframLink : 'https://amineaabada.github.io/Filter-Project/',
    description : '"The Filter Project is a dynamic tool allowing users to organize and categorize data efficiently. With customizable filters and sorting options, it simplifies the navigation and retrieval of specific information, enhancing productivity and user experience in managing diverse datasets."',
  },
  {id:20,
    projectTitle: "Alarm-App ",
    category: ["javascript"],
    imgPath: "./Images/Alarm-App.jpg",
    GitHubLink : "https://github.com/AminEaabada/Alarme-App" ,
    IframLink : 'https://amineaabada.github.io/Alarme-App/',
    description : '"🕰️⏰ An intuitive Alarm App built with React, providing a sleek interface for setting and managing alarms. Enjoy customizable features and responsive design for a seamless user experience. #ReactJS #WebDevelopment"',
  },
  {id:21,
    projectTitle: "Basic-Login ",
    category: ["javascript"],
    imgPath: "./Images/Basic-Login.png",
    GitHubLink : "https://github.com/AminEaabada/Basic-Login" ,
    IframLink : 'https://amineaabada.github.io/Basic-Login/',
    description : '"Basic-Login" is a simple login system providing essential user authentication features. Built with clarity in mind, it facilitates secure access control, making it an ideal foundation for projects requiring straightforward user login functionality.',
  },
  {id:22,
    projectTitle: "Basic-Calculator ",
    category: ["javascript"],
    imgPath: "./Images/Basic-Calculator.png",
    GitHubLink : "https://github.com/AminEaabada/Basic-Calculator" ,
    IframLink : 'https://amineaabada.github.io/Basic-Calculator/',
    description : '"Basic-Calculator" is a simple yet powerful calculator built for easy and straightforward use. Featuring essential arithmetic functions, it serves as a foundation for more advanced calculators or provides a quick solution for basic mathematical tasks',
  },
  {id:23,
    projectTitle: "Tour-Travel-Website ",
    category: ["react"],
    imgPath: "./Images/Tour-Travel-Website (1).png",
    GitHubLink : "https://github.com/AminEaabada/Tour-Travel" ,
    IframLink : 'https://amineaabada.github.io/Tour-Travel/',
    description : '"✈️🌍 Tour & Travel Website: Dynamic and responsive travel platform built with React.js. Explore captivating destinations, view enticing tours, and plan your next adventure seamlessly. Stunning UI, smooth navigation, and real-time updates. Embark on a journey with React! #ReactJS #TravelWebsite #WebDevelopment"',
  },
  {id:24,
    projectTitle: "Accordion ",
    category: ["html-css"],
    imgPath: "./Images/Accordion.jpg",
    GitHubLink : "https://github.com/AminEaabada/Accordion" ,
    IframLink : 'https://amineaabada.github.io/Accordion/',
    description : '"🎼📚 Accordion Component: Create interactive and stylish accordions with ease using JavaScript, HTML, and CSS. Enhance your web pages with collapsible content, smooth animations, and customizable styles. Elevate user experience effortlessly! #JavaScript #HTML #CSS #AccordionComponent"',
  },
  {id:25,
    projectTitle: "Adkare App (اذكار ) ",
    category: ["react"],
    imgPath: "./Images/Adkare.png",
    GitHubLink : "" ,
    IframLink : '',
    description : '',
  },

];

